import { PatchVisitFormQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVisitForm/patchVisitFormQuery.type';
import { patchVisitFormFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVisitForm/patchVisitFormQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchVisitFormQueryOptions = () => {
  return useMutation({
    mutationKey: ['patchVisitFormQueryOptions'],
    mutationFn: (params: PatchVisitFormQueryParamsType) =>
      patchVisitFormFunction(params),
  });
};
